module.exports = __webpack_public_path__ + "static/articMain-b384967de1fe85b157e06860bcaa282e.jpg";